// src/components/pages/Home/WeddingCategoriesSection/WeddingCategoriesSection.jsx

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaHeart, FaBookmark } from 'react-icons/fa';
import '../../../assets/css/customer/events/Category.css';

const Category = () => {
  const navigate = useNavigate();

  // Navigation handlers for each category
  const handleVenuesExplore = () => {
    navigate('/venues');
  };

  const handlePhotographersExplore = () => {
    navigate('/services'); // or create a photographers route
  };

  const handleServicesExplore = () => {
    navigate('/services');
  };

  const handleAmenitiesExplore = () => {
    navigate('/services'); // or create an amenities route
  };

  const handleConnectNow = () => {
    navigate('/customer/login');
  };

  return (
    <section className="wedding-categories-section-wcs">
      
      {/* Wedding Categories Header */}
      <div className="categories-header-wcs">
        <h2 className="main-heading-wcs">Wedding Categories</h2>
        <div className="flower-divider-wcs">
          <div className="divider-line-wcs left-line-wcs"></div>
          <img 
            src="/assets/images/flower-icon.png" 
            alt="Flower" 
            className="flower-icon-wcs"
          />
          <div className="divider-line-wcs right-line-wcs"></div>
        </div>
      </div>

      {/* Categories Grid with Center Image */}
      <Container>
        <div className="categories-grid-wrapper-wcs">
          
          {/* Left Column - Top Card - VENUES */}
          <div className="category-item-wcs left-top-wcs">
            <img 
              src="https://i.pinimg.com/736x/71/45/a0/7145a0b0e6afb9eadce6a238f6a6d589.jpg"
              alt="Venues" 
              className="category-img-wcs"
            />
            <div className="category-info-wcs">
              <h3 className="category-title-wcs">Venues</h3>
              <p className="category-description-wcs">
                Banquet Halls, Lawns / Farmhouses, Resorts,
                Small Function / Party Halls, Destination
                Wedding, Kalyan Mandapam, 4 Star & Above
                Hotels
              </p>
              <button className="explore-link-wcs" onClick={handleVenuesExplore}>
                Explore <span className="arrow-icon-wcs">→</span>
              </button>
            </div>
          </div>

          {/* Left Column - Bottom Card - PHOTOGRAPHERS */}
          <div className="category-item-wcs left-bottom-wcs">
            <img 
              src="https://i.pinimg.com/1200x/1f/af/fa/1faffa6eeff539a9ca13b4d9af4c4018.jpg" 
              alt="Photographers" 
              className="category-img-wcs"
            />
            <div className="category-info-wcs">
              <h3 className="category-title-wcs">Photographers</h3>
              <p className="category-description-wcs">
                Engagement, Pre-Wedding, Wedding, Post
                Wedding, Couples Shoot,
              </p>
              <button className="explore-link-wcs" onClick={handlePhotographersExplore}>
                Explore <span className="arrow-icon-wcs">→</span>
              </button>
            </div>
          </div>

          {/* Center - Couple Image */}
          <div className="center-couple-image-wcs">
            <img 
              src="https://i.pinimg.com/1200x/65/05/47/65054792f945ba686bdd94f2d6fd0551.jpg" 
              alt="Happy Couple" 
              className="couple-img-wcs"
            />
          </div>

          {/* Right Column - Top Card - SERVICES */}
          <div className="category-item-wcs right-top-wcs">
            <div className="category-info-wcs text-right-wcs">
              <h3 className="category-title-wcs">Services</h3>
              <p className="category-description-wcs">
                Air conditioned halls, Bridal room access,
                sound system
              </p>
              <button className="explore-link-wcs" onClick={handleServicesExplore}>
                Explore <span className="arrow-icon-wcs">→</span>
              </button>
            </div>
            <img 
              src="https://i.pinimg.com/736x/e2/16/b2/e216b20ae2afb56a356df2cb2f0d8abc.jpg" 
              alt="Groom and Bride Wear" 
              className="category-img-wcs"
            />
          </div>

          {/* Right Column - Bottom Card - AMENITIES */}
          <div className="category-item-wcs right-bottom-wcs">
            <div className="category-info-wcs text-right-wcs">
              <h3 className="category-title-wcs">Amenities</h3>
              <p className="category-description-wcs">
                Music & DJ, Floral Arrangements, Resorts,
                Photographer, Catering, 
              </p>
              <button className="explore-link-wcs" onClick={handleAmenitiesExplore}>
                Explore <span className="arrow-icon-wcs">→</span>
              </button>
            </div>
            <img 
              src="https://i.pinimg.com/736x/fd/d7/21/fdd72124e1d74d126c92d5ca0e572b7b.jpg" 
              alt="Mehandi" 
              className="category-img-wcs"
            />
          </div>

        </div>
      </Container>

      {/* Search Bar Section */}
      <Container>
        <div className="search-bar-section-wcs">
          <div className="search-wrapper-wcs">
            <input 
              type="text" 
              placeholder="What are you looking for?" 
              className="search-input-wcs"
            />
            <select className="location-select-wcs">
              <option>Shots</option>
              <option>Karachi</option>
              <option>Lahore</option>
              <option>Islamabad</option>
              <option>Multan</option>
            </select>
            <button className="search-button-wcs">
              <FaSearch />
            </button>
          </div>
        </div>
      </Container>

      {/* Available for Work & Follow Section */}
      <Container>
        <div className="action-buttons-section-wcs">
          <div className="left-actions-wcs">
            <button className="work-button-wcs">
              <span className="green-dot-wcs"></span>
              Available for work
            </button>
            <button className="follow-button-wcs">Follow</button>
          </div>
          <div className="right-icons-wcs">
            <FaHeart className="heart-icon-wcs" />
            <FaBookmark className="bookmark-icon-wcs" />
          </div>
        </div>
      </Container>

      {/* Promotional Banner */}
      <Container className="mt-5">
        <div className="promo-banner-wcs">

          {/* Center - Text Content */}
          <div className="promo-center-wcs">
            <h2 className="promo-heading-wcs">Let's Celebrate Your Love</h2>
            <p className="promo-subheading-wcs">20% Off Special Offer</p>
            <button className="connect-button-wcs" onClick={handleConnectNow}>Connect Now</button>
          </div>

          {/* Cloud Shapes Background */}
          <div className="cloud-shapes-wcs">
            <div className="cloud-wcs cloud-1-wcs"></div>
            <div className="cloud-wcs cloud-2-wcs"></div>
            <div className="cloud-wcs cloud-3-wcs"></div>
          </div>

        </div>
      </Container>

    </section>
  );
};

export default Category;